export enum ChannelPartnerGroupType {
    SubventedPreApproval = 'SubventedPreApproval'
}

export interface ChannelPartnerGroup {
    _id: string;
    type: ChannelPartnerGroupType;
}

interface PartnerMedia {
    logo: string;
    background?: string;
}

export class ChannelPartner {
    id: string;
    partnerName: string;
    partnerGroupIds: string[];
    advanceEmiPreferences: any;
    disbursalPreference: string;
    partnerMedia: PartnerMedia;

    constructor(id: string, partnerName: string, partnerGroupIds: string[], advanceEmiPreferences: any, disbursalPreference?: string, partnerMedia?: PartnerMedia) {
        this.id = id;
        this.partnerName = partnerName;
        this.partnerGroupIds = partnerGroupIds;
        this.advanceEmiPreferences = advanceEmiPreferences;
        this.disbursalPreference = disbursalPreference;
        this.partnerMedia = partnerMedia;
    }

    public static from(json: any): ChannelPartner {
        if (!json) {
            return json;
        }
        return new ChannelPartner(json._id, json.partner_name, json.partnerGroupIds, json.advanceEmiPreferences, json.disbursalPreference, json.partner_media);
    }

    public isAdvanceEmiPartner(): boolean {
        return this.advanceEmiPreferences && this.advanceEmiPreferences.length > 0;
    }
}
